jQuery(document).ready(function() {
    var owl = jQuery('.CarouselBanner1');
    owl.owlCarousel({
        margin: 0,
        loop: true,
        dots:true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            480: {
                items: 1
            },
            576: {
                items: 1
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            },
            1200: {
                items: 4
            }
        }
    })
})